module.exports = __webpack_public_path__ + "static/media/Bubble-image-12.2de40f26.png";